const moment = require('moment-timezone');

moment.locale('en');

const textMixins = {
  filters: {
    truncate(text, length, clamp) {
      const clampNew = clamp || '...';
      const lengthNew = length || 100;
      const node = document.createElement('div');
      node.innerHTML = text;
      const content = node.textContent;
      return content.length > lengthNew ? content.slice(0, lengthNew) + clampNew : content;
    },
    striphtml(text) {
      const node = document.createElement('div');
      node.innerHTML = text;
      const content = node.textContent;
      return content;
    },
    nicedate(date, style, custom) {
      let dateformat;
      if (date == null) {
        return '';
      }
      // Special case
      if (style === 'relative') {
        const now = moment().subtract(24, 'hours');
        if (moment(date).isAfter(now)) {
          return moment(date).fromNow();
        }
        return moment(date).format('MMM Do, YYYY');
        // return moment(date).format('MMM Do, YYYY h:mm a');
      }

      switch (style) {
        case 'long':
          dateformat = 'dddd, MMM Do h:mm a';
          break;

        case 'medium':
          dateformat = 'MM/DD/YYYY hh:mm a';
          break;

        case 'small':
          dateformat = 'MMM Do, YYYY';
          break;

        case 'xsmall':
          dateformat = 'h:mm a';
          break;

        case 'custom':
          dateformat = custom;
          break;

        default:
          dateformat = 'LLL';
          break;
      }
      return moment(date).isValid() ? moment(date).format(dateformat) : date;
    },
    formatPrice(price, decimals = 0) {
      // XXX vue-i18n's $n() dosen't work here!?!  WTFFF  (maybe try this.$n ?)
      // also NOTE:  vue-i18n $n()'s currency localization handles what 'numberWithCommas' does

      if (typeof price !== 'number') {
        return price;
      }
      const val = (price / 1).toFixed(decimals); // round to given number of decimals

      // return `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;   // ORIGINAL

      // XXX vue-i18n handles this
      const numberWithCommas = `${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
      const formatted = `$${numberWithCommas}`;
      return formatted;
    },
    formatFloat(number, decimals = 0) {
      if (typeof (number) !== 'number') {
        return number;
      }
      return Math.round((number + Number.EPSILON) * 10 ** decimals) / 10 ** decimals;
    },
    capitalize(str) {
      return str.replace(/(?:^|\s)\S/g, (match) => match.toUpperCase());
    },

  },
  methods: {
    parseAspectRatio(ratioString) {
      const regex = /^(\d+):(\d+)$/g;
      // check if matches
      const parts = regex.exec(ratioString);
      if (!parts) {
        return null;
      }
      const [, w, h] = parts.map((value, index) => (index === 0 ? value : parseInt(value, 10)));
      return [w, h];
    },
    isURL(str) {
      const urlPattern = /^(https?|ftp|torrent|image|irc):\/\/(-\.)?([^\s/?.#]+\.?)+(\/[^\s]*)?$/i;
      return !!urlPattern.test(str);
    },
    isEmail(str) {
      // eslint-disable-next-line
      const emailPattern = /^mailto:[\w-\.]+@([\w-]+\.)+[\w-]{2,4}(\?subject=test)?$/i;
      return !!emailPattern.test(str);
    },
    isiMessage(str) {
      // eslint-disable-next-line
      const iMessageNumericPattern = /^iMessage:\/\/\d{4,12}$/i;
      // eslint-disable-next-line
      const iMessageMailingPattern = /^iMessage:\/\/[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i;
      return (!!iMessageNumericPattern.test(str) || iMessageMailingPattern.test(str));
    },
    isSMS(str) {
      const smsPattern = /^sms:\+\d{4,12}$/;
      return !!smsPattern.test(str);
    },
    isWsp(str) {
      const wspPattern = /^https:\/\/wa\.me\/\d{4,12}$/;
      return !!wspPattern.test(str);
    },
    // eslint-disable-next-line
    isValidMailtoUrl(url) {
      // Basic validation for mailto URL
      const urlRegex = /^mailto:[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\?(subject|body)=(.+))?$/;
      if (!urlRegex.test(url)) {
        return false;
      }

      // If there are no parameters, it's already valid
      if (!url.includes('?')) {
        return true;
      }

      // Parse the URL and its query parameters
      const urlParts = url.split('?');
      const queryParams = new URLSearchParams(urlParts[1]);

      // Check for 'subject' and 'body' GET parameters
      const hasSubjectParam = queryParams.has('subject');
      const hasBodyParam = queryParams.has('body');

      // Any other parameters are considered invalid
      // eslint-disable-next-line
      for (const pair of queryParams.entries()) {
        if (pair[0] !== 'subject' && pair[0] !== 'body') {
          return false;
        }
      }
      // The URL is valid if it has both, one, or none of 'subject' and 'body' GET parameters
      return hasSubjectParam || hasBodyParam || (!hasSubjectParam && !hasBodyParam);
    },
  },
};

export default textMixins;
